import * as React from 'react';

import styles from './index.module.sass';

export const Skeleton: React.FC = () => <div className={styles.skelly} />;
